import { jsx as _jsx } from "react/jsx-runtime";
import { motion } from 'framer-motion';
import { cn } from '../../utils';
import { transition } from './animation';
import { ModalViews } from './views';
export function ModalPanel({ className, initial = 'initial', }) {
    return (_jsx(motion.div, { initial: initial, animate: "in", exit: "out", variants: transition, className: cn('fixed top-0 left-0 w-full h-full flex justify-center z-70 pointer-events-none', 'items-end [@media(min-width:640px)]:items-center'), children: _jsx("div", { onClick: (e) => e.stopPropagation(), className: cn('bg-surface flex flex-col max-h-[90%] max-w-160 w-full pointer-events-auto overflow-hidden', '[@media(min-width:640px)]:rounded-b-3xl rounded-t-3xl', className), children: _jsx(ModalViews, {}) }) }));
}
